import React, { Component } from 'react';
import debounce from 'lodash/debounce';
import {
  TextField,
  PasswordField,
  Button,
  ButtonType,
  HelpPanel,
  HelpItemType
} from '@riotgames/accounts-react-components';
import validator from '../util/validator';
import AppContext from '../AppContext';

import cx from 'classnames';
import { Grid, GridAlignment, GridDirection, GridJustify } from '@riotgames/accounts-react-components/lib/Grid';
import { GridPanel } from '@riotgames/accounts-react-components/lib/Grid/GridPanel';

class IdPasswd extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      validForm: false,
      validationFormMsg: '',
      validationFormRules: {
        confirmPassword: true
      },
      pending: false,
      forms: {
        username: {
          value: '',
          valid: false,
          touched: false,
          infoMsg: '영문으로 시작하는 4~24자의 영문+숫자로 입력해주세요.',
          validationMsg: '',
          validationRules: {
            isRequired: true,
            minLength: 4,
            maxLength: 24,
            alphaNumberic: true,
            badKeywords: true
          }
        },
        password: {
          value: '',
          valid: false,
          touched: false,
          infoMsg: '8자리 이상의 영문, 숫자, 특수문자 조합을 입력하세요.',
          validationMsg: '',
          validationRules: {
            minLength: 8,
            maxLength: 24,
            forbiddenChar: true,
            alphabet: true,
            number: true,
            specialChar: true,
            onlyAsciiChars: true,
            duplicatedChars: true,
            similarName: true,
            isRequired: true
          }
        },
        confirmPassword: {
          value: '',
          valid: false,
          touched: false,
          infoMsg: '비밀번호를 한 번 더 입력해 주세요',
          validationMsg: '',
          validationRules: {
            minLength: 8,
            maxLength: 24,
            forbiddenChar: true,
            alphabet: true,
            number: true,
            specialChar: true,
            onlyAsciiChars: true,
            duplicatedChars: true,
            similarName: true,
            isRequired: true
          }
        }
      }
    };

    this.debouncer = [];
  }

  debounceHandleChange = (name) => {
    if (this.debouncer[name]) {
      return this.debouncer[name];
    }

    this.debouncer[name] = debounce((decouncedInvoke) => {
      decouncedInvoke();
    }, 10);

    return this.debouncer[name];
  };

  changeHandler = async (name, value, rules) => {
    // valid to false when user changes value
    this.setState({
      validForm: false
    });

    await this.updateState(name, value);

    const { forms } = this.state;
    this.debounceHandleChange(name)(async () => {
      const debounceRule = rules || forms[name].lazyValidationRules;

      if (forms[name].valid && debounceRule) {
        await this.updateState(name, value, debounceRule);
      }

      this.debounceHandleChange('form')(() => {
        this.updateValidForm(); // watch out: maybe need to synchronous state.
      });
    });
  };

  updateValidForm = async () => {
    const { forms, validationFormRules } = this.state;
    let validForm = true;
    let validationFormMsg = '';

    // if (forms.password.value && forms.confirmPassword.value) {
    const { isValid, validationMsg } = await validator(forms.password.value, validationFormRules, {
      confirmPwd: forms.confirmPassword.value
    });

    validForm = isValid;
    validationFormMsg = validationMsg;
    // }

    // console.group('dd');
    // console.log(validForm, validationFormMsg);
    for (const identifier in forms) {
      // checking each input field is valid
      validForm = validForm && forms[identifier].valid;
    }
    // console.log(validForm, validationFormMsg);
    // console.groupEnd('dd');

    this.setState({
      validForm,
      validationFormMsg
    });
  };

  updateState = async (name, value, rules) => {
    const updatedFormState = {
      ...this.state.forms
    };
    const updatedElement = {
      ...updatedFormState[name]
    };
    const validationRules = rules ? rules : updatedElement.validationRules;

    const { isValid, validationMsg } = await validator(value, validationRules, {
      username: this.state.forms.username.value,
      actions: this.context.actions
    });

    updatedElement.valid = isValid;
    updatedElement.validationMsg = validationMsg || '';
    updatedElement.touched = true;
    updatedElement.value = value;

    updatedFormState[name] = updatedElement;

    this.setState({
      forms: updatedFormState
    });
  };

  update(params) {
    const { actions } = this.context;
    actions.setData(params);
  }

  syncUpdateContext = async () => {
    const {
      forms: { username, password }
    } = this.state;
    const { actions } = this.context;

    await actions.setData({
      username: username.value,
      password: password.value
    });

    this.moveNext();
  };

  moveNext() {
    this.props.handleMoveNext();
  }

  buildPasswordErrorDisplay(password, confirmPassword, validForm, validationFormMsg) {
    if (!password.touched && !confirmPassword.touched) {
      return {
        isPasswordAndConrifmValid: true,
        msgPasswordAndConrifmValid: password.infoMsg
      };
    } else if (password.touched && !password.valid) {
      return {
        isPasswordAndConrifmValid: false,
        msgPasswordAndConrifmValid: password.validationMsg
      };
    } else if (!password.touched && confirmPassword.touched) {
      return {
        isPasswordAndConrifmValid: false,
        msgPasswordAndConrifmValid: password.infoMsg
      };
    } else if (password.valid && !confirmPassword.touched) {
      return {
        isPasswordAndConrifmValid: true,
        msgPasswordAndConrifmValid: password.infoMsg
      };
    } else if (password.valid && confirmPassword.valid && password.value === confirmPassword.value) {
      // care about ordering #1
      return {
        isPasswordAndConrifmValid: true,
        msgPasswordAndConrifmValid: validationFormMsg
      };
    } else if (password.valid && confirmPassword.touched && !validForm) {
      // care about ordering #2
      return {
        isPasswordAndConrifmValid: false,
        msgPasswordAndConrifmValid: validationFormMsg
      };
    }
  }

  render() {
    const {
      validForm,
      validationFormMsg,
      pending,
      forms: { username, password, confirmPassword }
    } = this.state;

    const { isPasswordAndConrifmValid, msgPasswordAndConrifmValid } = this.buildPasswordErrorDisplay(
      password,
      confirmPassword,
      validForm,
      validationFormMsg
    );

    return (
      <GridPanel
        title={'아이디/비밀번호 입력'}
        button={<Button buttonType={ButtonType.submit} disabled={!validForm} onClick={this.syncUpdateContext} />}
      >
        <Grid
          direction={GridDirection.vertical}
          align={GridAlignment.center}
          justify={GridJustify.spaceBetween}
          fill={true}
        >
          <Grid direction={GridDirection.vertical} align={GridAlignment.center} fill={true}>
            <TextField
              label="아이디"
              name="username"
              animate={true}
              value={username.value}
              error={username.touched && !username.valid}
              disabled={pending}
              onValueChange={this.changeHandler.bind(this, 'username')}
              onBlur={() => this.changeHandler('username', username.value, username.callbackValidationRules)}
            />
            <HelpPanel
              items={[
                {
                  type: username.touched && !username.valid ? HelpItemType.error : HelpItemType.hint,
                  text: username.validationMsg || username.infoMsg
                }
              ]}
              animate={false}
            />
          </Grid>

          <Grid direction={GridDirection.vertical} align={GridAlignment.center} fill={true}>
            <PasswordField
              label="비밀번호"
              name="password"
              animate={true}
              animationDelay={0.1}
              value={password.value}
              error={password.touched && !password.valid}
              disabled={pending}
              onValueChange={this.changeHandler.bind(this, 'password')}
            />
            <PasswordField
              label="비밀번호 확인"
              name="confirmPassword"
              animate={true}
              animationDelay={0.2}
              value={confirmPassword.value}
              error={
                (confirmPassword.touched && !confirmPassword.valid) ||
                (confirmPassword.touched && !isPasswordAndConrifmValid)
              }
              disabled={pending}
              onValueChange={this.changeHandler.bind(this, 'confirmPassword')}
            />
            <HelpPanel
              items={[
                {
                  type: isPasswordAndConrifmValid ? HelpItemType.hint : HelpItemType.error,
                  text: msgPasswordAndConrifmValid
                }
              ]}
              animate={false}
            />
          </Grid>
        </Grid>
      </GridPanel>
    );
  }
}

export default IdPasswd;
